import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ['image']

    connect() {
        this.url = this.element.dataset.url;
        this.id = this.element.dataset.id;
        this.action = this.element.dataset.context;

        this.defaultText = this.element.innerHTML;
        this.loading = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'

    }

    addToCart(event) {
        event.preventDefault();
        this.element.innerHTML =  this.loading;
        this.buildAjax(this.url, this.id);
    }

    buildAjax(url, id) {
        let _self = this
        $.ajax({
            data: {id: id},
            url: url,
            method: 'POST',
            success: function (result) {
                _self.successAjax(result)
            },
        });
    }

    successAjax(result) {
        this.element.innerHTML = this.defaultText;
        // let modal = $('#checkout-modal');
        // modal.modal('show');

        let successMessage = $('#success');
        let failMessage = $('#fail');

        if (result.success === false) {
            successMessage.hide();
            failMessage.text(result.message);
            failMessage.addClass('cart-delivery-hint');
            failMessage.show();

            return;

        } else {
            successMessage.show();
            failMessage.hide();
        }

        EventManager.fire('item-added', result.cart);
        EventManager.fire('cart-updated', result.cart);

        let event = {
            event: 'add_to_cart',
            eventData: result.variant,
            unique_event_id: result.unique_event_id,
            action: this.action,
            cart: result.cart
        }
        EventManager.fire('gtm-event', event);
    }
}
